import { Button } from "PFComponents/button";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

const ResetButton = ({ onClick }) => {
  const { t } = useTranslation();
  return <Button text={t("reset")} kind="text" onClick={onClick} />;
};

ResetButton.propTypes = {
  onClick: PropTypes.func
};

export default ResetButton;
